import { defineComponent } from 'vue';
import ButtonElement from '@common/layout/ButtonElement.vue';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
export default defineComponent({
    name: 'Actions',
    compatConfig: {
        MODE: 3,
    },
    components: {
        ButtonElement,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        iconName: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            default: BootstrapVariant.PRIMARY,
        },
    },
    emits: ['click'],
});
